'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author Sean sean.snow@live.com
 * @date 2015/12/27
 */

var Character = (function () {
    function Character() {
        _classCallCheck(this, Character);
    }

    _createClass(Character, null, [{
        key: 'forDigit',

        /**
         * Determines the character representation for a specific digit in
         * the specified radix. If the value of {@code radix} is not a
         * valid radix, or the value of {@code digit} is not a valid
         * digit in the specified radix, the null character
         * ({@code '\u005Cu0000'}) is returned.
         * <p>
         * The {@code radix} argument is valid if it is greater than or
         * equal to {@code MIN_RADIX} and less than or equal to
         * {@code MAX_RADIX}. The {@code digit} argument is valid if
         * {@code 0 <= digit < radix}.
         * <p>
         * If the digit is less than 10, then
         * {@code '0' + digit} is returned. Otherwise, the value
         * {@code 'a' + digit - 10} is returned.
         *
         * @param   digit   the number to convert to a character.
         * @param   radix   the radix.
         * @return String  the {@code char} representation of the specified digit
         *          in the specified radix.
         * @see     Character#MIN_RADIX
         * @see     Character#MAX_RADIX
         * @see     Character#digit(String, Number)
         */
        value: function forDigit(digit, radix) {
            if (digit >= radix || digit < 0) {
                return '\0';
            }
            if (radix < Character.MIN_RADIX || radix > Character.MAX_RADIX) {
                return '\0';
            }
            if (digit < 10) {
                return String.fromCharCode('0'.charCodeAt(0) + digit);
            }
            return String.fromCharCode('a'.charCodeAt(0) - 10 + digit);
        }
    }]);

    return Character;
})();

Character.MIN_RADIX = 2;
Character.MAX_RADIX = 36;
exports.default = Character;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdk/lang/Character.js
// module id = 65
// module chunks = 0